import type { FaireProductEntity } from "../../entity_types/product";

export const p_njpp5nt5uw: FaireProductEntity = {
  token: "p_njpp5nt5uw",
  type: "product",
  name: "18K Gold Stainless Steel Mama Charm Holder Necklace Gift Set",
  brandToken: "b_99ch5ye698",
  brandName: "WJW",
  imageUrl:
    "https://cdn.faire.com/fastly/5b42fb7b87119565b7f97eb38fa9038624efa5de608b98462343fbb114983752.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0bf036bc4edf81cc958f99b4a9b325fc2fa097b4483fe80f6c23d23df81ec9e7.jpeg",
    "https://cdn.faire.com/fastly/bf1fc17eac352d92269cf02067f684ba1407eab3db1fb665643635b3bf07e4f8.jpeg",
    "https://cdn.faire.com/fastly/f9e5f1cfd190979097f9fd6d794111696ff1dd79f564b2878f719e1f1f0a5fa5.jpeg",
    "https://cdn.faire.com/fastly/6dd1920fb478d34ff104f9e4e982593c00e5f97586f0e0c5ee688b7dcfbc9899.jpeg",
    "https://cdn.faire.com/fastly/6e42fd86743da122b60d1705eeb553f37cd5f6d3adee3bbbab631ecbfdfed0d7.jpeg",
    "https://cdn.faire.com/fastly/6faf4641f98cfb8ffa858e38a2f5eaa57aa3271f7d76f868be36951b5ad7b34e.jpeg",
    "https://cdn.faire.com/fastly/542df971be9e791611ac660af38cdba8ea7e78124aefb156788cb4537d724254.jpeg",
    "https://cdn.faire.com/fastly/0420375ad6acfaf413493fb7f4deb3afbdd56596373bfce5cc2dddf8fcf0a84e.jpeg",
    "https://cdn.faire.com/fastly/de295d3d95aa78218e5d5d72af01e2d011053cf74b918ba802263114faee1b6f.jpeg",
  ],
  priceDollars: 15.07,
  description:
    'The perfect Mother’s Day gift for mom. \n\nThis 18K Gold PVD Stainless Steel Mama Carabiner Charm Gift Set is a thoughtfully curated set featuring a stylish charm holder and three beautifully designed charms, all packaged in an elegant gift box. Crafted in durable stainless steel with a radiant 18K gold PVD finish, it offers lasting shine and everyday wearability. The carabiner charm holder makes it easy to add, mix, or swap charms, creating a personalized look that’s uniquely hers.\n\nPerfect as a meaningful gift or a personal keepsake, this set is designed to bring love and sentiment to every jewelry collection.\n\n✦ Made with 18K Gold PVD Coated Stainless Steel \n✦ Size/Dimension(Carabiner Charm Holder):16"+2" Extension\n✦ Size/Dimension(Charms): Charm Size Varies based on Style\n\nSet includes the following: \n1 Paperclip Charm Holder Necklace, 3 Coordinating Charms, 1 Gift Box – ready for gifting\n\n- PVD COATING -\nWe use the process of PVD Coating our 18K Gold jewelry over 316L surgical grade stainless steel for a non-tarnish, hypoallergenic, polished finish that will hold up best to everyday wear and will never turn your customer\'s skin green.\n\nSame day shipping from Destin, FL before 3:00 PM CST.',
  tags: [],
  msrpDollars: 32.87,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-19T21:22:47.495Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
